import styled from 'styled-components';

export const Container = styled.div`
  padding-left: ${({ theme }) => theme.spacing.km10};
  padding-right: ${({ theme }) => theme.spacing.km10};
  padding-top: ${({ theme }) => theme.spacing.km16};
`;

export const Title = styled.h5`
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m5};
  line-height: ${({ theme }) => theme.font.lineHeight.tiny};
  color: ${({ theme }) => theme.color.text.neutral.default};
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`;
